<template>
    <router-link :to="{ name: 'Country', params: {country: countryFullName}}"
    class="border-countries-btn"
    >{{countryFullName}}
    </router-link>
</template>

<script>
export default {
    props: ['countryCode'],
    data() {
        return{
            countryFullName: null
        }
    },
    mounted() {
        fetch(`https://restcountries.eu/rest/v2/alpha/${this.countryCode}`)
            .then(res => res.json())
            .then(data => {
                this.countryFullName = data.name
                console.log(data.name)
            })
            .catch(err => console.log(err));
    }
    
}
</script>

<style lang="scss">
.border-countries-btn {
    display: block;
    background-color: hsl(0, 0%, 100%);
    padding: .5em 1em;
    box-shadow: 0 0px 10px rgba($color: #000000, $alpha: .05);
    border-radius: 5px;
    text-decoration: none;
    color: inherit;
    cursor: default;
    @media (min-width: 48em) {
        cursor: pointer;
    }
}

</style>